import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  body {
    align-items: center;
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    transition: all 0.25s linear;
  }

  a {
    color: ${({ theme }) => theme.anchor};
  }

  a:hover {
    color: ${(props) => props.theme.linkHoverColor} !important;
  }

  .breadcrumb-dark {
    background-color: ${({ theme }) => theme.breadCrumb} !important;
  }

  .breadcrumb > .active a {
    color: ${({ theme }) => theme.breadCrumbActive} !important;
  }

  .jumbotron {
    padding: 70px 30px 70px 30px;
    margin: 0px auto;
    background: ${({ theme }) => theme.jumboTronBackground};
    color: ${({ theme }) => theme.jumboTronColor};
  }

  .footer {
    background-color:${({ theme }) => theme.footerBackground};
    color: ${({ theme }) => theme.footerColor};
    margin: 0px auto;
    padding: 20px 0px 20px 0px;
  }

  address {
    font-size: 80%;
    margin: 0px;
    color: ${({ theme }) => theme.addressColor};
  }

  .btn {
    background-color: ${({ theme }) => theme.btnBackgroundColor};
    color: ${({ theme }) => theme.btnColor};
  }

  .card {
    background-color: ${({ theme }) => theme.cardBackGround};
  }

  .card-img-overlay {
    color: ${({ theme }) => theme.cardImgOverlay} !important;
  }

  .btn-toggler {
    background-color: ${({ theme }) => theme.btnToggler} !important;
  }

  .modal-custom .modal-content {
    background-color: ${({ theme }) => theme.modalBackground} !important;
    color: ${({ theme }) => theme.modalColor} !important;
  }

  .page-enter {
    opacity: 0.01;
    transform: translateX(-100%);
  }

  .page-enter-active {
    opacity: 1;
    transform: translateX(0%);
    transition: all 300ms ease-in;
  }

  .page-exit {
    opacity: 1;
    transform: translateX(0%);
  }

  .page-exit-active {
    opacity: 0.01;
    transform: translateX(100%);
    transition: all 300ms ease-out;
  }

  .active {
    color: ${(props) => props.theme.linkHoverColor} !important;
  }

  .navbar-custom {
    background-color: ${(props) => props.theme.navBarBgColor} !important;
  }
`;
